import React from 'react';
import { motion } from 'framer-motion';
export function LogoStrip() {
  const firms = ['Lavaux Peinture A. Meshi', 'Siegenthaler Peinture Sàrl', 'EC Plâtrerie Peinture', 'MAS-Peinture Sàrl', 'GS Peinture Sàrl', 'DIAZ DECO DESIGN Sàrl'];
  return <section className="py-6 sm:py-10 bg-white border-b border-gray-100" data-id="element-45">
      <div className="max-w-7xl mx-auto px-4" data-id="element-46">
        <p className="text-center text-xs sm:text-sm text-gray-500 mb-3 sm:mb-6" data-id="element-47">
          Geprüfte Malerfirmen auf Ofri – zum Beispiel:
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-5 sm:gap-x-10 gap-y-1.5 sm:gap-y-3" data-id="element-48">
          {firms.map((name, i) => <motion.div key={name} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.05
        }} className={`text-gray-400 font-semibold text-xs sm:text-base tracking-wide ${i >= 3 ? 'hidden sm:block' : ''} ${i >= 5 ? 'sm:hidden' : ''}`} data-id="element-49">
              {name}
            </motion.div>)}
        </div>
      </div>
    </section>;
}